module.exports = __webpack_public_path__ + "img/国防科技大学空天科学学院.385b4ce3.png";